module.exports = __webpack_public_path__ + "img/server_status.4de70ce5.svg";